import { useContext } from 'react'
import { AdvancedModeContext } from 'contexts/AdvancedMode'

function AdvancedMode({ children }) {
    const [mode] = useContext(AdvancedModeContext)
    
    return (mode === "true" ? children : null)  
}

export default AdvancedMode